import { withStyles } from '@material-ui/core/styles';
import ClientListInput from './ClientListInput';
import styles from './ClientListInput.styles';

export default withStyles(styles)(ClientListInput);
